import { render, staticRenderFns } from "./Servidor.vue?vue&type=template&id=766b62a8&scoped=true&"
import script from "./Servidor.vue?vue&type=script&lang=js&"
export * from "./Servidor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766b62a8",
  null
  
)

export default component.exports